import { MenuDetailsSettingsBuilder } from "./menu.details.builder";
//3 attributes

export class MenuDetailsSettings {
  public readonly instructions: string;
  public readonly warning: string;
  public readonly heroImage: string;
  constructor(builder: MenuDetailsSettingsBuilder) {
    this.instructions = builder.instructions;
    this.warning = builder.warning;
    this.heroImage = builder.heroImage;
  }
}
